export default __webpack_public_path__ + "static/rsz_questiee-96da3ad5602b97dec03782be1706581c.png";